import React from "react";

// Subtle topographic mountains SVG used as decorative background.
// Linear, "map-like" contour lines — Bieszczady silhouette.
export const BieszczadyBg = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 1440 600"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    preserveAspectRatio="xMidYMax slice"
  >
    <g stroke="#1A3826" strokeWidth="1" opacity="0.22" fill="none">
      <path d="M0 520 C 200 470, 380 540, 560 500 S 920 440, 1120 480 S 1320 520, 1440 500" />
      <path d="M0 480 C 180 430, 360 510, 540 470 S 900 410, 1100 450 S 1320 490, 1440 470" />
      <path d="M0 440 C 200 400, 360 470, 520 430 S 880 380, 1080 420 S 1320 460, 1440 440" />
      <path d="M0 400 C 220 360, 360 430, 500 390 S 860 350, 1060 390 S 1320 430, 1440 410" />
      <path d="M40 360 C 240 320, 380 400, 500 350 S 840 310, 1040 360 S 1300 400, 1440 380" />
      <path d="M120 320 C 280 290, 400 360, 520 320 S 820 280, 1020 330 S 1280 370, 1440 350" />
      <path d="M200 280 C 320 260, 440 320, 560 290 S 800 250, 1000 290 S 1260 330, 1440 320" />
    </g>
    {/* Soft mountain silhouettes */}
    <g fill="#1A3826" opacity="0.06">
      <path d="M0 600 L 0 460 L 140 360 L 260 420 L 380 320 L 520 410 L 660 300 L 800 400 L 940 320 L 1080 410 L 1220 340 L 1360 420 L 1440 380 L 1440 600 Z" />
    </g>
  </svg>
);

export default BieszczadyBg;
